angular.module('app.parametrizacion', [
  'ui.router',
  'toastr',
  'app.parametrizacionService'
])
  
.config(
  [          '$stateProvider', '$urlRouterProvider',
    function ($stateProvider,   $urlRouterProvider) {
      $stateProvider
        .state('index.parametrizacion', {

          abstract: true,

          url: 'parametrizacion',

          params: {
            
          },

          views: {
            '': {
              templateUrl: 'app/parametrizacion/parametrizacion.tpl.html',
              resolve: {

              },
              controller: ['$scope', '$state', 'toastr',
                function (  $scope,   $state,   toastr) {

                  
                  
                }]
            }
          }
          
        })
        .state( 'index.parametrizacion.catalogoscj', {

          url: '/catalogoscj',

          views: {
            '': {
              templateUrl: 'app/parametrizacion/parametrizacion.catalogoscj.tpl.html',
              resolve: {
                 dataMaterias: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getMaterias();
                  }],
                  dataCompetencias: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getCompetenciasA();
                  }],
                  dataTipoProcesos: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getTipoProcesosA();
                  }],
                  dataClases: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getClasesA();
                  }],
                  dataSubclases: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getSubclasesA();
                  }],
                  dataTipoAsunto: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getTipoAsuntoA();
                  }],
                  dataCJs: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getClasificacionesJuridicas();
                  }]
                  /*,
                  permisoEstado : ['authService',
                  function( authService){
                    return authService.loginPermission(31);
                  }]*/
              },
              controller: ['$scope', '$state', 'toastr','parametrizacionService','dataMaterias','dataCompetencias','dataTipoProcesos',
                           'dataClases','dataSubclases','dataCJs','dataTipoAsunto',
                function (  $scope,   $state,   toastr , parametrizacionService , dataMaterias , dataCompetencias , dataTipoProcesos , 
                            dataClases , dataSubclases , dataCJs,dataTipoAsunto) {

                  $scope.formNew={};
                  $scope.formEdt={};
                  $scope.cj={};


                  $scope.dataMaterias = dataMaterias.data;
                  $scope.dataCompetencias = dataCompetencias.data;
                  $scope.dataTipoProcesos = dataTipoProcesos.data;
                  $scope.dataClases = dataClases.data;
                  $scope.dataSubclases = dataSubclases.data;
                  $scope.dataTipoAsunto = dataTipoAsunto.data;
                  
                  // $scope.gridOptionsCJs = angular.copy( $scope.gridOptions);
                  //    $scope.gridOptionsCJs.columnDefs = [
                  //     { name: 'ID_CLASIFICACION_JURIDICA', displayName: "ID" , visible:false},
                  //     { name: 'COMPETENCIA', displayName: "Competencia",width:'15%'},
                  //     { name: 'MATERIA', displayName: "Materia",width:'15%'},
                  //     { name: 'TIPO_PROCESO', displayName: "Tipo Proceso",width:'15%'},
                  //     { name: 'CLASE', displayName: "Clase",width:'15%'},
                  //     { name: 'SUBCLASE', displayName: "Subclase",width:'15%'},
                  //     { name: 'ASUNTO', displayName: "Asunto",width:'15%'},
                  //     { name: 'OPCIONES', enableFiltering: false, width:'10%', cellTemplate: 'app/parametrizacion/parametrizacion.catalogoscj.options.tpl.html' }
                  //    ];
                  // $scope.gridOptionsCJs.data = dataCJs.data;

                  $scope.dataCJs = [];
                  $scope.dataCJs = dataCJs.data;


                  $scope.selectedMateria = function (Item) {
                   
                    $scope.formEdt.ID_MATERIA=Item.ID_MATERIA;
                    $scope.formEdt.MATERIA=Item.MATERIA;
                   
                  }

                  $scope.selectedCompetencia = function (Item) {
                   
                      $scope.formEdt.ID_COMPETENCIA=Item.ID_COMPETENCIA;
                      $scope.formEdt.COMPETENCIA=Item.COMPETENCIA;
                  }

                  if ($scope.dataCompetencias.lengt = 1)
                  {
                    $scope.cj.ID_COMPETENCIA=$scope.dataCompetencias[0].ID_COMPETENCIA;
                  }


                  $scope.selectedTipoProceso = function (Item) {
                    
                      $scope.formEdt.ID_TIPO_PROCESO=Item.ID_TIPO_PROCESO;
                      $scope.formEdt.TIPO_PROCESO=Item.TIPO_PROCESO;
                  }

                  $scope.selectedClase = function (Item) {
                    
                      $scope.formEdt.ID_CLASE=Item.ID_CLASE;
                      $scope.formEdt.CLASE=Item.CLASE;
                  }

                  $scope.selectedSubclase = function (Item) {
                    
                      $scope.formEdt.ID_SUBCLASE=Item.ID_SUBCLASE;
                      $scope.formEdt.SUBCLASE=Item.SUBCLASE;
                  }
                  if ($scope.dataSubclases.lengt = 1)
                  {
                    $scope.cj.ID_SUBCLASE=$scope.dataSubclases[0].ID_SUBCLASE;
                  }

                  $scope.selectedTipoAsunto = function (Item) {
                    
                      $scope.formEdt.ID_TIPO_ASUNTO=Item.ID_TIPO_ASUNTO;
                      $scope.formEdt.TIPO_ASUNTO=Item.TIPO_ASUNTO;
                  }
                  /*$scope.EdtMateria = function () {                    
                    if($scope.formEdt.MATERIA != null){
                      
                      parametrizacionService.EdtMateria( $scope.formEdt ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formEdt.MATERIA=null;  
                          parametrizacionService.getMaterias( ).then( function ( response ) {
                            $scope.dataMaterias = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_MATERIA=null;                  
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }*/

                  /*$scope.EdtCompetencia = function () {                    
                    if($scope.formEdt.COMPETENCIA != null){
                     
                      parametrizacionService.EdtCompetencia( $scope.formEdt ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formEdt.COMPETENCIA=null;
                          parametrizacionService.getCompetenciasA( ).then( function ( response ) {
                            $scope.dataCompetencias = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_COMPETENCIA=null;                          
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }*/

                  $scope.EdtTipoProceso = function () {                    
                    if($scope.formEdt.TIPO_PROCESO != null){
                      parametrizacionService.EdtTipoProceso( $scope.formEdt ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formEdt.ID_TIPO_PROCESO=null;  
                          $scope.formEdt.TIPO_PROCESO=null;  
                          parametrizacionService.getTipoProcesosA( ).then( function ( response ) {
                            $scope.dataTipoProcesos = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_TIPO_PROCESO=null;                        
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }

                  $scope.EdtClase = function () {                    
                    if($scope.formEdt.CLASE != null){
                      parametrizacionService.EdtClase( $scope.formEdt ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formEdt.ID_CLASE=null;
                          $scope.formEdt.CLASE=null;
                          parametrizacionService.getClasesA( ).then( function ( response ) {
                            $scope.dataClases = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_CLASE=null;                          
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }

                  /*$scope.EdtSubclase = function () {                    
                    if($scope.formEdt.SUBCLASE != null){
                     
                      parametrizacionService.EdtSubclase( $scope.formEdt ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formEdt.SUBCLASE=null; 
                          parametrizacionService.getSubclasesA( ).then( function ( response ) {
                            $scope.dataSubclases = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_SUBCLASE=null; 

                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }*/


                  $scope.InsClasificacionJuridica = function (isValid) {   

                    if(isValid){
                      parametrizacionService.InsClasificacionJuridica( $scope.cj ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          // $scope.cj.ID_MATERIA=null; 
                          // $scope.cj.ID_COMPETENCIA=null; 
                          $scope.cj.ID_TIPO_PROCESO=null; 
                          $scope.cj.ID_CLASE=null; 
                          // $scope.cj.ID_SUBCLASE=null;
                          $scope.cj.ID_TIPO_ASUNTO=null;
                          $scope.cj.ID_CLASIFICACION_JURIDICA=null; 
                          $scope.formEdt.TIPO_PROCESO==null;
                          $scope.formEdt.CLASE==null;

                          parametrizacionService.getClasificacionesJuridicas( ).then( function ( response ) {
                            $scope.dataCJs = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });

                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }

                  /*$scope.InsMateria = function () {                    
                    if($scope.formNew.MATERIA != null){
                      
                      parametrizacionService.InsMateria( $scope.formNew ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formNew.MATERIA=null;  
                          parametrizacionService.getMaterias( ).then( function ( response ) {
                            $scope.dataMaterias = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_MATERIA=response.data.id;                    
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }*/

                  /*$scope.InsCompetencia = function () {                    
                    if($scope.formNew.COMPETENCIA != null){
                      
                      parametrizacionService.InsCompetencia( $scope.formNew ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formNew.COMPETENCIA=null;
                          parametrizacionService.getCompetenciasA( ).then( function ( response ) {
                            $scope.dataCompetencias = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_COMPETENCIA=response.data.id;                          
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }*/

                  $scope.InsTipoProceso = function () {                    
                    if($scope.formNew.TIPO_PROCESO != null){
                      
                      parametrizacionService.InsTipoProceso( $scope.formNew ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formNew.TIPO_PROCESO=null;  
                          parametrizacionService.getTipoProcesosA( ).then( function ( response ) {
                            $scope.dataTipoProcesos = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_TIPO_PROCESO=null;                        
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }

                  $scope.InsClase = function () {                    
                    if($scope.formNew.CLASE != null){
                      parametrizacionService.InsClase( $scope.formNew ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formNew.CLASE=null;
                          parametrizacionService.getClasesA( ).then( function ( response ) {
                            $scope.dataClases = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_CLASE=null;
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }

                  /*$scope.InsSubclase = function () {                    
                    if($scope.formNew.SUBCLASE != null){
                      
                      parametrizacionService.InsSubclase( $scope.formNew ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.formNew.SUBCLASE=null; 
                          parametrizacionService.getSubclasesA( ).then( function ( response ) {
                            $scope.dataSubclases = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });
                          $scope.cj.ID_SUBCLASE=response.data.id; 

                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }*/

                  /*$scope.delMateria = function ( ) {
                    swal({
                      title: "¿Desea eliminar la Materia "+ $scope.formEdt.MATERIA + "?",
                      text: "",
                      showCancelButton: true,
                      confirmButtonClass: "btn-success",
                      confirmButtonText: "Confirmar",
                      cancelButtonClass: "btn-danger",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: true,
                    },
                    function () {
                       parametrizacionService.delMateria( $scope.formEdt ).then( function ( response ) {
                       
                        if(response.data.result=='OK'){
                            toastr.success( response.data.msj );
                            $scope.formEdt.MATERIA=null;
                            $scope.formEdt.ID_MATERIA=null;
                            parametrizacionService.getMaterias( ).then( function ( response ) {
                              $scope.dataMaterias = response.data;
                            }, function ( error ) {
                              toastr.error( error );
                            });
                            $scope.cj.ID_MATERIA=null;
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    });
                  }*/

                  /*$scope.delCompetencia = function ( ) {
                    swal({
                      title: "¿Desea eliminar la Competencia "+ $scope.formEdt.COMPETENCIA + "?",
                      text: "",
                      showCancelButton: true,
                      confirmButtonClass: "btn-success",
                      confirmButtonText: "Confirmar",
                      cancelButtonClass: "btn-danger",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: true,
                    },
                    function () {
                       parametrizacionService.delCompetencia( $scope.formEdt ).then( function ( response ) {
                      
                        if(response.data.result=='OK'){
                            toastr.success( response.data.msj );
                            $scope.formEdt.ID_COMPETENCIA=null;
                            $scope.formEdt.COMPETENCIA=null;
                            parametrizacionService.getCompetenciasA( ).then( function ( response ) {
                              $scope.dataMaterias = response.data;
                            }, function ( error ) {
                              toastr.error( error );
                            });
                            $scope.cj.ID_COMPETENCIA=null;
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    });
                  }*/

                  $scope.delTipoProceso = function ( ) {
                    swal({
                      title: "¿Desea eliminar el tipo de caso "+ $scope.formEdt.TIPO_PROCESO + "?",
                      text: "",
                      showCancelButton: true,
                      confirmButtonClass: "btn-danger",
                      confirmButtonText: "Continuar",
                      cancelButtonClass: "btn-default",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: true,
                    },
                    function () {
                       parametrizacionService.delTipoProceso( $scope.formEdt ).then( function ( response ) {
                       
                        if(response.data.result=='OK'){
                            toastr.success( response.data.msj );
                            $scope.formEdt.TIPO_PROCESO=null;
                            $scope.formEdt.ID_TIPO_PROCESO=null;
                            parametrizacionService.getTipoProcesosA( ).then( function ( response ) {
                              $scope.dataTipoProcesos = response.data;
                            }, function ( error ) {
                              toastr.error( error );
                            });
                            $scope.cj.ID_TIPO_PROCESO=null;
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    });
                  }
                  $scope.edtTipoProceso = function (item) {
                    swal({
                      title: "Editar tipo de caso",
                      text: "",
                      type: "input",
                      showCancelButton: true,
                      confirmButtonClass: "btn-warning",
                      confirmButtonText: "Continuar",
                      cancelButtonClass: "btn-default",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: false,
                      inputPlaceholder: "Ingrese tipo de caso",
                      inputValue:item.toUpperCase()
                    },
                    function (inputValue) {
                      if (inputValue === false) return false;
                      if (inputValue === "") {
                        swal.showInputError("Ingrese tipo de caso");
                        return false
                      }
                      $scope.formEdt.TIPO_PROCESO = inputValue.toUpperCase();
                      $scope.EdtTipoProceso();
                      swal.close();
                    })
                  }
                  $scope.insTipoProceso = function () {
                    swal({
                      title: "Agregar tipo de caso",
                      text: "",
                      type: "input",
                      showCancelButton: true,
                      confirmButtonClass: "btn-success",
                      confirmButtonText: "Continuar",
                      cancelButtonClass: "btn-default",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: false,
                      inputPlaceholder: "Ingrese tipo de caso"
                    },
                    function (inputValue) {
                      if (inputValue === false) return false;
                      if (inputValue === "") {
                        swal.showInputError("Ingrese tipo de caso");
                        return false
                      }
                      $scope.formNew.TIPO_PROCESO = inputValue.toUpperCase();
                      $scope.InsTipoProceso();
                      swal.close();
                    })
                  }

                  $scope.delClase = function ( ) {
                    swal({
                      title: "¿Desea eliminar la clase "+ $scope.formEdt.CLASE + "?",
                      text: "",
                      showCancelButton: true,
                      confirmButtonClass: "btn-danger",
                      confirmButtonText: "Confirmar",
                      cancelButtonClass: "btn-default",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: true,
                    },
                    function () {
                       parametrizacionService.delClase( $scope.formEdt ).then( function ( response ) {
                        if(response.data.result=='OK'){
                            toastr.success( response.data.msj );
                            $scope.formEdt.CLASE=null;
                            $scope.formEdt.ID_CLASE=null;
                            parametrizacionService.getClasesA( ).then( function ( response ) {
                              $scope.dataClases = response.data;
                            }, function ( error ) {
                              toastr.error( error );
                            });
                            $scope.cj.ID_CLASE=null;
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    });
                  }
                  $scope.edtClase = function (item) {
                    swal({
                      title: "Editar clase",
                      text: "",
                      type: "input",
                      showCancelButton: true,
                      confirmButtonClass: "btn-warning",
                      confirmButtonText: "Continuar",
                      cancelButtonClass: "btn-default",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: false,
                      inputPlaceholder: "Ingrese clase",
                      inputValue:item.toUpperCase()
                    },
                    function (inputValue) {
                      if (inputValue === false) return false;
                      if (inputValue === "") {
                        swal.showInputError("Ingrese clase");
                        return false
                      }
                      $scope.formEdt.CLASE = inputValue.toUpperCase();
                      $scope.EdtClase();
                      swal.close();
                    })
                  }
                  $scope.insClase = function (item) {
                    swal({
                      title: "Agregar clase",
                      text: "",
                      type: "input",
                      showCancelButton: true,
                      confirmButtonClass: "btn-success",
                      confirmButtonText: "Continuar",
                      cancelButtonClass: "btn-default",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: false,
                      inputPlaceholder: "Ingrese clase",
                      inputValue:item
                    },
                    function (inputValue) {
                      if (inputValue === false) return false;
                      if (inputValue === "") {
                        swal.showInputError("Ingrese clase");
                        return false
                      }
                      $scope.cj.ID_CLASE="";
                      $scope.formNew.ID_CLASE = "";
                      $scope.formNew.CLASE = inputValue.toUpperCase();
                      $scope.InsClase();
                      swal.close();
                    })
                  }

                  /*$scope.delSubclase = function ( ) {
                    swal({
                      title: "¿Desea eliminar la Subclase "+ $scope.formEdt.SUBCLASE + "?",
                      text: "",
                      showCancelButton: true,
                      confirmButtonClass: "btn-success",
                      confirmButtonText: "Confirmar",
                      cancelButtonClass: "btn-danger",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: true,
                    },
                    function () {
                       parametrizacionService.delSubclase( $scope.formEdt ).then( function ( response ) {
                      
                        if(response.data.result=='OK'){
                            toastr.success( response.data.msj );
                            $scope.formEdt.SUBCLASE=null;
                            $scope.formEdt.ID_SUBCLASE=null;
                            parametrizacionService.getSubclasesA( ).then( function ( response ) {
                              $scope.dataSubclases = response.data;
                            }, function ( error ) {
                              toastr.error( error );
                            });
                            $scope.cj.ID_SUBCLASE=null;
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    });
                  }*/


                  $scope.delClasificacionJuridica = function (row) {
                    swal({
                      title: "¿Desea eliminar la clasificación jurídica seleccionada?",
                      text: "",
                      showCancelButton: true,
                      confirmButtonClass: "btn-danger",
                      confirmButtonText: "Confirmar",
                      cancelButtonClass: "btn-default",
                      cancelButtonText: "Cancelar",
                      closeOnConfirm: true,
                    },
                    function () {
                      $scope.cj.ID_CLASIFICACION_JURIDICA=row.ID_CLASIFICACION_JURIDICA;
                       parametrizacionService.delClasificacionJuridica( $scope.cj ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );
                          $scope.cj.ID_MATERIA=null; 
                          // $scope.cj.ID_COMPETENCIA=null; 
                          $scope.cj.ID_TIPO_PROCESO=null; 
                          $scope.cj.ID_CLASE=null; 
                          // $scope.cj.ID_SUBCLASE=null;
                          $scope.cj.ID_TIPO_ASUNTO=null;
                          $scope.cj.ID_CLASIFICACION_JURIDICA=null; 
                          $scope.formEdt.TIPO_PROCESO==null;
                          $scope.formEdt.CLASE==null;

                          parametrizacionService.getClasificacionesJuridicas( ).then( function ( response ) {
                            $scope.dataCJs = response.data;
                          }, function ( error ) {
                            toastr.error( error );
                          });

                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    });
                  }




                }] 
            }
          }
        })
        .state( 'index.parametrizacion.cj', {

          url: '/cj',

          views: {
            '': {
              templateUrl: 'app/parametrizacion/parametrizacion.cj.tpl.html',
              resolve: {
                  dataMaterias: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getMaterias();
                  }],
                  dataDepartamentos: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getDepartamentos();
                  }],
                  /*dataDespachos: ['parametrizacionService',
                  function( parametrizacionService){
                   return parametrizacionService.getDespachos(-1,-1);
                  }]
                  , 
                  permisoEstado : ['authService',
                  function( authService){
                    return authService.loginPermission(32);
                  }]*/
              },
              controller: ['$scope', '$state', 'toastr','parametrizacionService','dataDepartamentos','dataMaterias',
                function (  $scope,   $state,   toastr , parametrizacionService , dataDepartamentos , dataMaterias ) {

                  $scope.formDespacho={};

                  $scope.dataDepartamentos = dataDepartamentos.data;
                  $scope.dataDespachos = [];
                  $scope.dataMaterias = dataMaterias.data;


                  // $scope.gridOptionsClasificacionesDespacho = angular.copy( $scope.gridOptions);
                  //    $scope.gridOptionsClasificacionesDespacho.columnDefs = [
                  //    { name: 'ACTIVO', displayName: 'ACTIVO', width:'10%',cellTemplate: '<input type="checkbox" ng-click="grid.appScope.VinculaCJ(row.entity)" ng-model="row.entity.ACTIVO">'},
                  //     { name: 'ID_CLASIFICACION_JURIDICA', displayName: "ID" , width:'8%', visible:false},
                  //     { name: 'MATERIA', displayName: "Materia" ,width:'15%'},
                  //     { name: 'COMPETENCIA', displayName: "Competencia",width:'15%'},
                  //     { name: 'TIPO_PROCESO', displayName: "Tipo Proceso",width:'15%'},
                  //     { name: 'CLASE', displayName: "Clase",width:'15%' },
                  //     { name: 'SUBCLASE', displayName: "Subclase",width:'15%' }  , 
                  //     { name: 'TIPO_ASUNTO', displayName: "Asunto",width:'15%' } 
                      
                  //    ];
                  // $scope.gridOptionsClasificacionesDespacho.data = [];
                  $scope.dataClasificacionesDespacho = [];
                  
                  verificarEstadoCheckbox = function (arreglo) 
                  {
                    $scope.checkbox = {};
                    seleccionados=0;
                    desseleccionados=0;
                    for (var i=0; i < arreglo.length; i++) 
                    {
                      if (arreglo[i].ACTIVO) 
                      {
                        seleccionados++;
                      }
                      else
                      {
                        desseleccionados++;
                      }
                    }
                    if ((seleccionados > 0) && (desseleccionados == 0))
                    {
                      $scope.checkbox.ACTIVO = true;
                      $scope.tooltip_checkbox_clasificacion = "Deseleccionar todos";
                    }
                    else 
                    {
                      $scope.checkbox.ACTIVO = false;
                      $scope.tooltip_checkbox_clasificacion = "Seleccionar todos";
                    }
                  }

                  $scope.CargaDespacho = function (isValid) {
                    if(isValid){
                      $scope.MuestraDetalleDespacho=true;
                      parametrizacionService.getClasificacionesDespacho( $scope.formDespacho.ID_DESPACHO ).then( function ( response ) {
                        $scope.dataClasificacionesDespacho = response.data;
                        verificarEstadoCheckbox($scope.dataClasificacionesDespacho);
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }

                  $scope.VinculaCJ = function (row) {
                    if(row.ACTIVO){
                      parametrizacionService.InsClasificacionDespacho( row ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          if (!row.SELECCION_GENERAL)
                          {
                            toastr.success( response.data.msj );
                          }
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }else{
                      parametrizacionService.DelClasificacionDespacho( row ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          if (!row.SELECCION_GENERAL)
                          {
                            toastr.success( response.data.msj );
                          }
                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }
                  
                  $scope.asignarTodos = function (item) 
                  {
                    for (var i=0; i < $scope.dataClasificacionesDespacho.length; i++) 
                    {
                      $scope.dataClasificacionesDespacho[i].ACTIVO = item;
                      $scope.dataClasificacionesDespacho[i].SELECCION_GENERAL = true;
                      $scope.VinculaCJ($scope.dataClasificacionesDespacho[i]);
                    }
                    if (item)
                    {
                      toastr.success("Clasificaciones jurídicas despacho asignadas correctamente");
                    }
                    else
                    {
                      toastr.success("Clasificaciones jurídicas despacho desasignadas correctamente");
                    }
                    verificarEstadoCheckbox($scope.dataClasificacionesDespacho);
                  }

                  

                  $scope.selectedDepartamento = function () {
                    if($scope.formDespacho.ID_DEPARTAMENTO>0){
                      $scope.formDespacho.ID_DESPACHO=null;
                      $scope.MuestraDetalleDespacho=false;
                      // parametrizacionService.getDespachos($scope.formDespacho.ID_DEPARTAMENTO,-1 ).then( function ( response ) {
                      //   $scope.dataDespachos = response.data;
                      // }, function ( error ) {
                      //   toastr.error( error );
                      // });
                      $scope.formDespacho.ID_MUNICIPIO=null;
                      parametrizacionService.getMunicipios($scope.formDespacho.ID_DEPARTAMENTO,-1 ).then( function ( response ) {
                        $scope.dataMunicipios = response.data;
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }

                  $scope.selectedMunicipio = function () {
                    if($scope.formDespacho.ID_MUNICIPIO>0){
                      $scope.formDespacho.ID_DESPACHO=null;
                      $scope.MuestraDetalleDespacho=false;
                      parametrizacionService.getDespachos($scope.formDespacho.ID_DEPARTAMENTO,$scope.formDespacho.ID_MUNICIPIO,$scope.CONSTANTES.COMPETENCIA).then( 
                        function ( response ) 
                        {                   
                          $scope.dataDespachos = response.data;
                        }, 
                        function ( error ) 
                        {
                          toastr.error( error );
                        });
                    }
                  }

                  $scope.selectedDespacho = function (item) {
                    if($scope.formDespacho.ID_DESPACHO!=null){
                      //$scope.formCJ.ID_DESPACHO=$scope.formDespacho.ID_DESPACHO;
                      $scope.CargaDespacho(true);
                      $scope.MuestraDetalleDespacho=true;
                    }else{
                      $scope.MuestraDetalleDespacho=false;
                    }
                  }

                  $scope.selectedMateria = function (Item) {
                    parametrizacionService.getCompetencias(  $scope.formCJ.ID_MATERIA  ).then( function ( response ) {
                      $scope.dataCompetencias = response.data;
                        $scope.dataTipoProcesos = [];
                        $scope.dataClases = [];
                        $scope.dataSubclases = [];
                        $scope.formCJ.ID_COMPETENCIA=null;
                        $scope.formCJ.ID_TIPO_PROCESO=null;
                        $scope.formCJ.ID_CLASE=null;
                        $scope.formCJ.ID_SUBCLASE=null;
                    }, function ( error ) {
                        toastr.error( error );
                    });

                  }

                  $scope.selectedCompetencia = function (Item) {
                    parametrizacionService.getTipoProcesos(  $scope.formCJ.ID_MATERIA,$scope.formCJ.ID_COMPETENCIA  ).then( function ( response ) { 
                      $scope.dataTipoProcesos = response.data;
                        $scope.dataClases = [];
                        $scope.dataSubclases = [];
                        $scope.formCJ.ID_TIPO_PROCESO=null;
                        $scope.formCJ.ID_CLASE=null;
                        $scope.formCJ.ID_SUBCLASE=null;
                    }, function ( error ) {
                        toastr.error( error );
                    });
                  }


                  $scope.selectedTipoProceso = function (Item) {
                    parametrizacionService.getClases($scope.formCJ.ID_MATERIA,$scope.formCJ.ID_COMPETENCIA,$scope.formCJ.ID_TIPO_PROCESO ).then( function ( response ) {
                      $scope.dataClases = response.data;
                        $scope.dataSubclases = [];
                        $scope.formCJ.ID_CLASE=null;
                        $scope.formCJ.ID_SUBCLASE=null;
                    }, function ( error ) {
                        toastr.error( error );
                    });
                  }

                  $scope.selectedClase = function (Item) {
                    parametrizacionService.getSubclases($scope.formCJ.ID_MATERIA,$scope.formCJ.ID_COMPETENCIA,$scope.formCJ.ID_TIPO_PROCESO,$scope.formCJ.ID_CLASE ).then( function ( response ) {
                      $scope.dataSubclases = response.data;
                        $scope.formCJ.ID_SUBCLASE=null;
                    }, function ( error ) {
                        toastr.error( error );
                    });
                  }

                  $scope.selectedSubclase = function (Item) {
                    $scope.formCJ.ID_CLASIFICACION_JURIDICA=Item.ID_CLASIFICACION_JURIDICA;                    
                    
                  }


                  $scope.RegistraCJ = function (isValid) {   
                    if(isValid){
                      parametrizacionService.InsClasificacionDespacho( $scope.formCJ ).then( function ( response ) {
                        if(response.data.result=='OK'){
                          toastr.success( response.data.msj );

                           $scope.MuestraDetalleDespacho=true;
                            parametrizacionService.getClasificacionesDespacho( $scope.formCJ.ID_DESPACHO ).then( function ( response ) {
                              $scope.dataClasificacionesDespacho = response.data;
                            }, function ( error ) {
                              toastr.error( error );
                            });

                        }else{
                          toastr.error(response.data.msj );
                        }
                      }, function ( error ) {
                        toastr.error( error );
                      });
                    }
                  }



                }]
            }
          }
        })
        .state( 'index.parametrizacion.despachos', {

          url: '/centros',

          views: {
            '': {
              templateUrl: 'app/parametrizacion/parametrizacion.despachos.tpl.html',
              resolve: {

              },
              controller: ['$scope', '$state', 'toastr','parametrizacionService', 'ngDialog',
                function (  $scope,   $state,   toastr , parametrizacionService, ngDialog) {

                  getDespachos = function()
                  {
                    parametrizacionService.getDespachos(-1,-1, $scope.CONSTANTES.COMPETENCIA).then( 
                      function ( response ) {
                          $scope.dataDespachos = [];
                          $scope.dataDespachos = response.data;
                        }, function ( error ) {
                          toastr.error( error );
                        });
                  }

                  getDespachos();

                  $scope.viewContacto = function(item)
                  {
                    $scope.dialogShowContacto = ngDialog.open(
                    {
                      template: 'app/parametrizacion/parametrizacion.contacto.view.tpl.html',
                      showClose:true,
                      closeByEscape: true,
                      preCloseCallback:function()
                        {
                          getDespachos();
                        },
                      className: 'ngdialog-theme-flat-custom custom-width',
                      resolve: 
                      {
                        dataTipoContacto: ['casosService',
                        function(casosService)
                        {
                          return casosService.getTipoContacto();
                        }]  
                      },
                      scope:$scope,
                      controller: ['$scope', '$filter', 'dataTipoContacto', function($scope, $filter, dataTipoContacto) 
                      {
                        $scope.nombre_centro = item.DESPACHO;
                        $scope.seccion_datos = false;
                        $scope.seccion_datos_tipo = false;
                        longitud_minima_caja_contacto = 15;
                        $scope.datosContacto = {};
                        
                        $scope.tipoContacto = [];
                        $scope.tipoContacto = dataTipoContacto.data;
                        cambiar_tipo_dato = function()
                        {
                          if (($scope.seccion_datos == false) && ($scope.seccion_datos_tipo == false))
                          {
                            $scope.seccion_datos = true;
                          }
                          else if (($scope.seccion_datos == true) && ($scope.seccion_datos_tipo == false))
                          {
                            $scope.seccion_datos = false;
                            $scope.seccion_datos_tipo = true;
                          }
                          else
                          {
                            $scope.seccion_datos = true;
                            $scope.seccion_datos_tipo = false;
                          }       
                        }
                        $scope.selectedTipoContacto = function (item)
                        {
                          $scope.longitud_minima_caja_contacto = 0;
                          if (item.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                          {
                            $scope.longitud_minima_caja_contacto = longitud_minima_caja_contacto;
                          }
                          cambiar_tipo_dato();
                          $scope.datosContacto.CONTACTO = item.CONTACTO;
                          $scope.datosContacto.ICONO = item.ICONO;
                          $scope.datosContacto.ID_CONTACTO = item.ID_CONTACTO;
                          $scope.datosContacto.ID_CONTACTO_DESPACHO = item.ID_CONTACTO_DESPACHO;
                          $scope.datosContacto.ID_TIPO_CONTACTO = item.ID_TIPO_CONTACTO;
                          $scope.datosContacto.MASCARA = item.MASCARA;
                        }
                        $scope.getContactoCentro = function()
                        {
                          parametrizacionService.getContactoCentro(item.ID_DESPACHO).then( 
                            function ( response ) {
                                $scope.MOSTRAR_ELIMINACION = false;
                                $scope.editar_contacto = false;
                                $scope.seccion_datos = false;
                                $scope.seccion_datos_tipo = false;
                                $scope.dataContactos = [];
                                $scope.dataContactos = response.data;
                              }, function ( error ) {
                                toastr.error( error );
                              });
                        }
                        $scope.getContactoCentro();

                        $scope.guardarContacto = function(isValid)
                        {
                          if (isValid)
                          {
                            $scope.datosContacto.ID_DESPACHO = item.ID_DESPACHO;
                            if ($scope.editar_contacto == true)
                            {
                              edtContactoCentro($scope.datosContacto);
                            }
                            else
                            {
                              insContactoCentro($scope.datosContacto);
                            }
                          }
                          else
                          {
                            toastr.warning("Faltan datos por ingresar");
                          }
                        }

                        insContactoCentro =  function(item)
                        {
                          parametrizacionService.insContactoCentro(item).then(
                            function (response)
                            {
                              if(response.data.result=='OK')
                              {
                                toastr.success(response.data.msj);
                                $scope.getContactoCentro();
                                $scope.datosContacto = {};
                              }
                              else
                              {
                                toastr.error(response.data.msj);
                              }                      
                            },
                            function (error) 
                            {
                              toastr.error( error );
                            }); 
                        }

                        edtContactoCentro =  function(item)
                        {
                          parametrizacionService.edtContactoCentro(item).then(
                            function (response)
                            {
                              if(response.data.result=='OK')
                              {
                                toastr.success(response.data.msj);
                                $scope.getContactoCentro();
                                $scope.datosContacto = {};
                              }
                              else
                              {
                                toastr.error(response.data.msj);
                              }                      
                            },
                            function (error) 
                            {
                              toastr.error( error );
                            }); 
                        }

                        $scope.eliminarContacto =  function()
                        {
                          parametrizacionService.delContactoCentro($scope.datosContacto).then(
                            function (response)
                            {
                              if(response.data.result=='OK')
                              {
                                toastr.success(response.data.msj);
                                $scope.getContactoCentro();
                                $scope.datosContacto = {};
                              }
                              else
                              {
                                toastr.error(response.data.msj);
                              }                      
                            },
                            function (error) 
                            {
                              toastr.error( error );
                            }); 
                        }

                        direccionesCentro = function(valor, arreglo){
                          direcciones = 0;
                          for (var i=0; i < arreglo.length; i++) {
                              if (arreglo[i].ID_TIPO_CONTACTO === valor) {
                                direcciones++;
                              }
                          }
                          return direcciones;
                        }

                        $scope.editar_contacto = false;
                        $scope.editarContacto = function(item)
                        {
                          if (item.isSelected == true)
                          {
                            if (direccionesCentro($scope.CONSTANTES.TIPO_CONTACTO_DIRECCION, $scope.datosContacto) > 1)
                            {
                              $scope.MOSTRAR_ELIMINACION = true;
                            }
                            else if (item.ID_TIPO_CONTACTO != $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION) 
                            {
                              $scope.MOSTRAR_ELIMINACION = true;
                            }
                            else 
                            {
                              $scope.MOSTRAR_ELIMINACION = false;
                            }
                            $scope.editar_contacto = true;
                            $scope.selectedTipoContacto(item);
                          }
                          else
                          {
                            $scope.MOSTRAR_ELIMINACION = false;
                            $scope.editar_contacto = false;
                            $scope.seccion_datos = false;
                            $scope.seccion_datos_tipo = false;
                            $scope.datosContacto = {};
                          }
                        }
                      }] 
                    });
                  } 


                  // $scope.formDespacho={};

                  // $scope.dataDepartamentos = dataDepartamentos.data;
                  // $scope.dataDespachos = [];
                  
                  /*$scope.dataMaterias = dataMaterias.data;*/


                  // $scope.gridOptionsClasificacionesDespacho = angular.copy( $scope.gridOptions);
                  //    $scope.gridOptionsClasificacionesDespacho.columnDefs = [
                  //    { name: 'ACTIVO', displayName: 'ACTIVO', width:'10%',cellTemplate: '<input type="checkbox" ng-click="grid.appScope.VinculaCJ(row.entity)" ng-model="row.entity.ACTIVO">'},
                  //     { name: 'ID_CLASIFICACION_JURIDICA', displayName: "ID" , width:'8%', visible:false},
                  //     { name: 'MATERIA', displayName: "Materia" ,width:'15%'},
                  //     { name: 'COMPETENCIA', displayName: "Competencia",width:'15%'},
                  //     { name: 'TIPO_PROCESO', displayName: "Tipo Proceso",width:'15%'},
                  //     { name: 'CLASE', displayName: "Clase",width:'15%' },
                  //     { name: 'SUBCLASE', displayName: "Subclase",width:'15%' }  , 
                  //     { name: 'TIPO_ASUNTO', displayName: "Asunto",width:'15%' } 
                      
                  //    ];
                  // $scope.gridOptionsClasificacionesDespacho.data = [];
                  
                  //$scope.dataClasificacionesDespacho = [];
                  
                  // verificarEstadoCheckbox = function (arreglo) 
                  // {
                  //   $scope.checkbox = {};
                  //   seleccionados=0;
                  //   desseleccionados=0;
                  //   for (var i=0; i < arreglo.length; i++) 
                  //   {
                  //     if (arreglo[i].ACTIVO) 
                  //     {
                  //       seleccionados++;
                  //       console.log(arreglo[i].ACTIVO,seleccionados);
                  //     }
                  //     else
                  //     {
                  //       desseleccionados++;
                  //     }
                  //   }
                  //   if ((seleccionados > 0) && (desseleccionados == 0))
                  //   {
                  //     $scope.checkbox.ACTIVO = true;
                  //     $scope.tooltip_checkbox_clasificacion = "Deseleccionar todos";
                  //   }
                  //   else 
                  //   {
                  //     $scope.checkbox.ACTIVO = false;
                  //     $scope.tooltip_checkbox_clasificacion = "Seleccionar todos";
                  //   }
                  // }

                  // $scope.CargaDespacho = function (isValid) {
                  //   if(isValid){
                  //     $scope.MuestraDetalleDespacho=true;
                  //     parametrizacionService.getClasificacionesDespacho( $scope.formDespacho.ID_DESPACHO ).then( function ( response ) {
                  //       $scope.dataClasificacionesDespacho = response.data;
                  //       verificarEstadoCheckbox($scope.dataClasificacionesDespacho);
                  //     }, function ( error ) {
                  //       toastr.error( error );
                  //     });
                  //   }
                  // }

                  // $scope.VinculaCJ = function (row) {
                  //   if(row.ACTIVO){
                  //     parametrizacionService.InsClasificacionDespacho( row ).then( function ( response ) {
                  //       if(response.data.result=='OK'){
                  //         if (!row.SELECCION_GENERAL)
                  //         {
                  //           toastr.success( response.data.msj );
                  //         }
                  //       }else{
                  //         toastr.error(response.data.msj );
                  //       }
                  //     }, function ( error ) {
                  //       toastr.error( error );
                  //     });
                  //   }else{
                  //     parametrizacionService.DelClasificacionDespacho( row ).then( function ( response ) {
                  //       if(response.data.result=='OK'){
                  //         if (!row.SELECCION_GENERAL)
                  //         {
                  //           toastr.success( response.data.msj );
                  //         }
                  //       }else{
                  //         toastr.error(response.data.msj );
                  //       }
                  //     }, function ( error ) {
                  //       toastr.error( error );
                  //     });
                  //   }
                  // }
                  
                  // $scope.asignarTodos = function (item) 
                  // {
                  //   for (var i=0; i < $scope.dataClasificacionesDespacho.length; i++) 
                  //   {
                  //     $scope.dataClasificacionesDespacho[i].ACTIVO = item;
                  //     $scope.dataClasificacionesDespacho[i].SELECCION_GENERAL = true;
                  //     $scope.VinculaCJ($scope.dataClasificacionesDespacho[i]);
                  //   }
                  //   if (item)
                  //   {
                  //     toastr.success("Clasificaciones jurídicas despacho asignadas correctamente");
                  //   }
                  //   else
                  //   {
                  //     toastr.success("Clasificaciones jurídicas despacho desasignadas correctamente");
                  //   }
                  //   verificarEstadoCheckbox($scope.dataClasificacionesDespacho);
                  // }

                  

                  // $scope.selectedDepartamento = function () {
                  //   if($scope.formDespacho.ID_DEPARTAMENTO>0){
                  //     $scope.formDespacho.ID_DESPACHO=null;
                  //     $scope.MuestraDetalleDespacho=false;
                  //     // parametrizacionService.getDespachos($scope.formDespacho.ID_DEPARTAMENTO,-1 ).then( function ( response ) {
                  //     //   $scope.dataDespachos = response.data;
                  //     // }, function ( error ) {
                  //     //   toastr.error( error );
                  //     // });
                  //     $scope.formDespacho.ID_MUNICIPIO=null;
                  //     parametrizacionService.getMunicipios($scope.formDespacho.ID_DEPARTAMENTO,-1 ).then( function ( response ) {
                  //       $scope.dataMunicipios = response.data;
                  //     }, function ( error ) {
                  //       toastr.error( error );
                  //     });
                  //   }
                  // }

                  // $scope.selectedMunicipio = function () {
                  //   if($scope.formDespacho.ID_MUNICIPIO>0){
                  //     $scope.formDespacho.ID_DESPACHO=null;
                  //     $scope.MuestraDetalleDespacho=false;
                  //     parametrizacionService.getDespachos($scope.formDespacho.ID_DEPARTAMENTO,$scope.formDespacho.ID_MUNICIPIO,$scope.CONSTANTES.COMPETENCIA).then( 
                  //       function ( response ) 
                  //       {                   
                  //         $scope.dataDespachos = response.data;
                  //       }, 
                  //       function ( error ) 
                  //       {
                  //         toastr.error( error );
                  //       });
                  //   }
                  // }

                  // $scope.selectedDespacho = function (item) {
                  //   if($scope.formDespacho.ID_DESPACHO!=null){
                  //     //$scope.formCJ.ID_DESPACHO=$scope.formDespacho.ID_DESPACHO;
                  //     $scope.CargaDespacho(true);
                  //     $scope.MuestraDetalleDespacho=true;
                  //   }else{
                  //     $scope.MuestraDetalleDespacho=false;
                  //   }
                  // }

                  // $scope.selectedMateria = function (Item) {
                  //   parametrizacionService.getCompetencias(  $scope.formCJ.ID_MATERIA  ).then( function ( response ) {
                  //     $scope.dataCompetencias = response.data;
                  //       $scope.dataTipoProcesos = [];
                  //       $scope.dataClases = [];
                  //       $scope.dataSubclases = [];
                  //       $scope.formCJ.ID_COMPETENCIA=null;
                  //       $scope.formCJ.ID_TIPO_PROCESO=null;
                  //       $scope.formCJ.ID_CLASE=null;
                  //       $scope.formCJ.ID_SUBCLASE=null;
                  //   }, function ( error ) {
                  //       toastr.error( error );
                  //   });

                  // }

                  // $scope.selectedCompetencia = function (Item) {
                  //   parametrizacionService.getTipoProcesos(  $scope.formCJ.ID_MATERIA,$scope.formCJ.ID_COMPETENCIA  ).then( function ( response ) { 
                  //     $scope.dataTipoProcesos = response.data;
                  //       $scope.dataClases = [];
                  //       $scope.dataSubclases = [];
                  //       $scope.formCJ.ID_TIPO_PROCESO=null;
                  //       $scope.formCJ.ID_CLASE=null;
                  //       $scope.formCJ.ID_SUBCLASE=null;
                  //   }, function ( error ) {
                  //       toastr.error( error );
                  //   });
                  // }


                  // $scope.selectedTipoProceso = function (Item) {
                  //   parametrizacionService.getClases($scope.formCJ.ID_MATERIA,$scope.formCJ.ID_COMPETENCIA,$scope.formCJ.ID_TIPO_PROCESO ).then( function ( response ) {
                  //     $scope.dataClases = response.data;
                  //       $scope.dataSubclases = [];
                  //       $scope.formCJ.ID_CLASE=null;
                  //       $scope.formCJ.ID_SUBCLASE=null;
                  //   }, function ( error ) {
                  //       toastr.error( error );
                  //   });
                  // }

                  // $scope.selectedClase = function (Item) {
                  //   parametrizacionService.getSubclases($scope.formCJ.ID_MATERIA,$scope.formCJ.ID_COMPETENCIA,$scope.formCJ.ID_TIPO_PROCESO,$scope.formCJ.ID_CLASE ).then( function ( response ) {
                  //     $scope.dataSubclases = response.data;
                  //       $scope.formCJ.ID_SUBCLASE=null;
                  //   }, function ( error ) {
                  //       toastr.error( error );
                  //   });
                  // }

                  // $scope.selectedSubclase = function (Item) {
                  //   $scope.formCJ.ID_CLASIFICACION_JURIDICA=Item.ID_CLASIFICACION_JURIDICA;                    
                    
                  // }


                  // $scope.RegistraCJ = function (isValid) {   
                  //   if(isValid){
                  //     parametrizacionService.InsClasificacionDespacho( $scope.formCJ ).then( function ( response ) {
                  //       if(response.data.result=='OK'){
                  //         toastr.success( response.data.msj );

                  //          $scope.MuestraDetalleDespacho=true;
                  //           parametrizacionService.getClasificacionesDespacho( $scope.formCJ.ID_DESPACHO ).then( function ( response ) {
                  //             $scope.dataClasificacionesDespacho = response.data;
                  //           }, function ( error ) {
                  //             toastr.error( error );
                  //           });

                  //       }else{
                  //         toastr.error(response.data.msj );
                  //       }
                  //     }, function ( error ) {
                  //       toastr.error( error );
                  //     });
                  //   }
                  // }



                }]
            }
          }
        })
    }
  ]
);